<template>
    <input :value="modelValue" type="hidden" @input="updateValue()" />
</template>

<script>
export default {
    name: 'ItemNullOption',
    props: {
        modelValue: {
            required: true,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        updateValue(event) {
            this.$emit('update:modelValue', event.target.value);
        },
    },
};
</script>
